module.exports = __webpack_public_path__ + "media/images/athletes/115-86e1b78bc49016c6290adcb05f90ccbd.png";